import "@/App.css";
import LeaseRenew from "@/pages/LeaseRenew";
import GuestPortal from "@/pages/GuestPortal";
import DamageReports from "@/pages/DamageReports";
import TurnoverPhotos from "@/pages/TurnoverPhotos";
import CleanerQuality from "@/pages/CleanerQuality";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Contacts from "@/pages/Contacts";
import ContactDetail from "@/pages/ContactDetail";
import Bookings from "@/pages/Bookings";
import Campaigns from "@/pages/Campaigns";
import Templates from "@/pages/Templates";
import Properties from "@/pages/Properties";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import Statements from "@/pages/Statements";
import Survey from "@/pages/Survey";
import GuestBook from "@/pages/GuestBook";
import Calendar from "@/pages/Calendar";
import Cleaning from "@/pages/Cleaning";
import DirectBook from "@/pages/DirectBook";
import PaymentSuccess from "@/pages/PaymentSuccess";
import DamagePaid from "@/pages/DamagePaid";
import PaymentCancel from "@/pages/PaymentCancel";
import Reports from "@/pages/Reports";
import LandlordPortal from "@/pages/LandlordPortal";
import GuestJourney from "@/pages/GuestJourney";
import Journeys from "@/pages/Journeys";
import Inbox from "@/pages/Inbox";
import GuestWishlist from "@/pages/GuestWishlist";
import WishlistWeeklyPreview from "@/pages/WishlistWeeklyPreview";
import SignedAgreements from "@/pages/SignedAgreements";
import TrainingGuides from "@/pages/TrainingGuides";
import CleaningCostAudit from "@/pages/CleaningCostAudit";
import StripeSmokeTest from "@/pages/StripeSmokeTest";
import BulkHistory from "@/pages/BulkHistory";
import Finance from "@/pages/Finance";
import Compliance from "@/pages/Compliance";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/survey/:token" element={<Survey />} />
            <Route path="/g/:slug" element={<GuestBook />} />
            <Route path="/book/:slug" element={<DirectBook />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/damage-paid" element={<DamagePaid />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/landlord" element={<LandlordPortal />} />
            <Route path="/wishlist" element={<GuestWishlist />} />
            <Route
              path="/wishlist/weekly-preview"
              element={
                <ProtectedRoute>
                  <WishlistWeeklyPreview />
                </ProtectedRoute>
              }
            />
            <Route path="/journey/:token" element={<GuestJourney />} />
            <Route path="/lease-renew/:token" element={<LeaseRenew />} />
            <Route
              path="/calendar"
              element={
                <ProtectedRoute>
                  <Calendar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cleaning"
              element={
                <ProtectedRoute>
                  <Cleaning />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts"
              element={
                <ProtectedRoute>
                  <Contacts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts/:id"
              element={
                <ProtectedRoute>
                  <ContactDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings"
              element={
                <ProtectedRoute>
                  <Bookings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/journeys"
              element={
                <ProtectedRoute>
                  <Journeys />
                </ProtectedRoute>
              }
            />
            <Route
              path="/signed-agreements"
              element={
                <ProtectedRoute>
                  <SignedAgreements />
                </ProtectedRoute>
              }
            />
            <Route
              path="/training-guides"
              element={
                <ProtectedRoute>
                  <TrainingGuides />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cost-audit"
              element={
                <ProtectedRoute>
                  <CleaningCostAudit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stripe-smoke-test"
              element={
                <ProtectedRoute>
                  <StripeSmokeTest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bulk-history"
              element={
                <ProtectedRoute>
                  <BulkHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inbox"
              element={
                <ProtectedRoute>
                  <Inbox />
                </ProtectedRoute>
              }
            />
            <Route
              path="/campaigns"
              element={
                <ProtectedRoute>
                  <Campaigns />
                </ProtectedRoute>
              }
            />
            <Route
              path="/templates"
              element={
                <ProtectedRoute>
                  <Templates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/properties"
              element={
                <ProtectedRoute>
                  <Properties />
                </ProtectedRoute>
              }
            />
            <Route
              path="/statements"
              element={
                <ProtectedRoute>
                  <Statements />
                </ProtectedRoute>
              }
            />
            <Route
              path="/finance"
              element={
                <ProtectedRoute>
                  <Finance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compliance"
              element={
                <ProtectedRoute>
                  <Compliance />
                </ProtectedRoute>
              }
            />
            <Route path="/damage-reports" element={<ProtectedRoute><DamageReports /></ProtectedRoute>} />
            <Route path="/turnover-photos" element={<ProtectedRoute><TurnoverPhotos /></ProtectedRoute>} />
            <Route path="/cleaner-quality" element={<ProtectedRoute><CleanerQuality /></ProtectedRoute>} />
            <Route
              path="/guest-portal"
              element={
                <ProtectedRoute>
                  <GuestPortal />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team"
              element={
                <ProtectedRoute>
                  <Team />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
